<template>
  <div class="center container">
    <img src="@/assets/logo-verde.png" class="logo-erro" />
    <div v-if="isNetworkError">
      <i class="material-icons grey-text text-lighten-1" style="font-size: 80px; margin-top: 20px;">wifi_off</i>
      <h4>Poxa, parece que a sua internet está um pouco lenta...</h4>
      <div class="row">
        <p class="col s12 grey-text text-darken-1" style="font-size: 1.1rem; line-height: 1.4;">
          Quer tentar novamente? Clica no botão abaixo e vamos lá!
        </p>
      </div>
    </div>
    <h4 v-else>Empresa não localizada :(</h4>

    <div v-if="retryPath" style="margin-top: 20px;">
      <button @click="tentarNovamente" class="btn-large waves-effect waves-light green darken-1 white-text" style="font-weight: bold; width: 100%; max-width: 300px;">
        TENTAR NOVAMENTE
      </button>
      
      <div v-if="reason" style="margin-top: 30px; color: #bbb; font-size: 11px; border-top: 1px solid #eee; padding-top: 15px;">
         <p>Info Diagnóstica: {{ reason }}</p>
         <p>Caminho: {{ retryPath }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Erro",
  computed: {
    retryPath() {
      return this.$route.query.retryPath;
    },
    reason() {
      return this.$route.query.reason;
    },
    isNetworkError() {
      if (!this.reason) return false;
      const r = this.reason.toLowerCase();
      // Se houver 404 no motivo, não é um erro de rede genérico, é empresa não encontrada
      if (r.includes("404")) return false; 
      
      return r.includes("network error") || 
             r.includes("timeout") || 
             r.includes("request failed") || 
             r.includes("failed to fetch") ||
             r.includes("fbq");
    }
  },
  methods: {
    tentarNovamente() {
      if (this.retryPath) {
        // Redireciona para o caminho original
        this.$router.push(this.retryPath);
      }
    }
  }
};
</script>

<style scoped>
.logo-erro {
  width: 45%;
  max-width: 400px;
  min-width: 250px;
  padding: 80px 20px 20px 20px;
}
h4 {
  font-weight: bold;
  color: #333;
}
</style>




// WEBPACK FOOTER //
// src/components/Paginas/Erro.vue